import {IHttpService} from "angular";
import {NewsItemId, NewsItemIds} from "app/news/types/NewsItemId";

export class ReadNewsItemsService {

    public static readonly id = "readNewsItemsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async readItems(): Promise<NewsItemIds> {
        const url = `/tradefloor/api/news/read-items`;
        const response = await this.$http.get<NewsItemIds>(url);
        return response.data;
    }

    public async readItem(id: NewsItemId): Promise<void> {
        const url = `/tradefloor/api/news/read-items/${id}`;
        await this.$http.put(url, null);
    }
}
